module.exports = __webpack_public_path__ + "img/mg.91e10ba0.svg";